import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  Checkbox,
  Radio,
  Modal,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { UserServices } from "../../../core/services/UserServices";
import { CompanyServices } from "../../../core/services/CompanyServices";
import { HelperServices } from "../../../core/services/HelperServices";
import "./User.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { displayField, isEmptyVal } from "../../../utils/helpers";
import {
  messageTypeArr,
  roleTypeArr,
  onOffArr,
  statusArr,
  roleObjArr,
  clientRoleArr,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "../../validators/ValidatorCustom";
import { isNotEmpty, isNotNull } from "../../../utils/helpers";
import { CompanyFields } from "../Companies/CompanyDataTypes";
import { UserListParams } from "./UserDataTypes";
function UserForCompany({
  companyId,
  forRole = roleObjArr.client_admin.id,
  openModal,
  setOpenModal,
  onComplete,
}: {
  companyId: number;
  forRole?: number;
  openModal: boolean;
  setOpenModal: Function;
  onComplete?: Function;
}) {
  const { t } = useTranslation();
  const [loader, setLoading] = useState(true);
  const [createNewUser, setCreateNewUser] = useState(false);
  const [companyData, setCompanyData] = useState<CompanyFields>({});
  const countryList = useSelector((state: any) => state.country.data);
  const params: any = useParams();
  const [file, setFile] = useState<any>();
  const [updateUserImage, setUpdateUserImage] = useState("");
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areas, setAreas] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [userList, setUserList] = useState([]);
  const [formData, setFormData] = useState<any>({
    emp_code: "",
    email: "",
    name: "",
    fname: "",
    lname: "",
    mobile: "",
    username: "",
    password: "",
    confirm_password: "",
    comp_id: "",
    city_id: "",
    designation: "",
    country_id: "",
    state_id: "",
    address_mobile: "",
    house_no: "",
    building: "",
    area_name: "",
    landmark: "",
    pincode: "",
    user_id: "",
    status: statusArr.active,
    receive_notification: onOffArr.on,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [cityNotFound, setCityNotFound] = useState(false);
  const [stateNotFound, setSateNotFound] = useState(false);
  const [userNotFound, setUserNotFound] = useState(false);
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [isUsernameAllowed, setIsUsernameAllowed] = useState(true);
  const areaRef = useRef<any>();
  const buildingRef = useRef<any>();
  async function init() {
    try {
      if (companyId) {
        const response: any = await CompanyServices.viewCompany(+companyId);
        const respData = get("data.data", response);
        setCompanyData(respData);

        const userParams: UserListParams = {
          company: companyId.toString(),
          role: forRole.toString(),
        };
        const responseUData: any = await UserServices.getUsers(userParams);
        const userList = get("data.data", responseUData);
        setUserList(userList);
        setUserNotFound(!userList.length);
        setFormData({
          ...formData,
          ...{ user_id: respData.primary_user_id },
        });
        userList.length ? setCreateNewUser(false) : setCreateNewUser(true);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function makeSameAddress(addressData: any, form: any) {
    if (addressData?.country_id) {
      form.change("country_id", addressData.country_id);
      handleCountryChange(addressData.country_id);
    }
    if (addressData?.state_id) {
      form.change("state_id", addressData.state_id);
      handleStateChange(addressData.state_id);
    }
    if (
      addressData?.city_id &&
      addressData?.state_id &&
      addressData?.country_id
    ) {
      form.change("city_id", addressData.city_id);
      searchArea("", addressData.city_id);
      searchBuilding("", addressData.city_id);
    }
    if (addressData?.area_name) {
      form.change("area_name", addressData.area_name);
    }
    if (addressData?.building_name) {
      form.change("building", addressData.building_name);
    }
    if (addressData?.landmark) {
      form.change("landmark", addressData.landmark);
    }
    if (addressData?.house_no) {
      form.change("house_no", addressData.house_no);
    }
    if (addressData?.pincode) {
      form.change("pincode", addressData.pincode);
    }
  }

  useEffect(() => {
    if (
      UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client &&
      UtilityServices.getLoggedInUser("company_id") != companyId
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("NO_PERMISSION"),
      });
      return;
    }
    if (!clientRoleArr.includes(forRole)) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("INVALID_ENTITY_ACCESS", {
          entity: t("ROLE").toLowerCase(),
        }),
      });
      return;
    }
    init();
  }, [companyId]);

  async function handleStateChange(stateId: any) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      const respData = get("data.data", res);
      setCityList(respData);
      setCityNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCountryChange(countryId: any) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      const respData = get("data.data", stateRes);
      setStateList(respData);
      setSateNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function saveUser(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await UserServices.updateUser(+id, form);
      } else {
        response = await UserServices.createUser(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      setOpenModal("");
      if (onComplete) {
        onComplete();
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const dbounceUsername = useCallback(
    debounce(500, (value: string) => {
      checkUserName(value);
    }),
    []
  );

  const handleUsernameCheck = (value: string) => {
    dbounceUsername(value);
  };

  async function checkUserName(name: string) {
    try {
      const res = await UserServices.checkUserNameAvailablity({
        username: name,
      });
      setIsUsernameAllowed(false);
    } catch (error: any) {
      setIsUsernameAllowed(true);
    }
  }

  const dbounceArea = useCallback(
    debounce(1000, (searchAreaValue: string, cityId: any) => {
      searchArea(searchAreaValue, +cityId);
    }),
    []
  );

  const handleAreaSearch = (value: any, cityId: any) => {
    dbounceArea(value, cityId);
  };

  async function searchArea(search: string, cityId: number) {
    try {
      if (search) {
        const res = await HelperServices.getAllValidAreas({
          city: cityId,
          smart_search: search,
        });
        setAreas(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const dbounceBuilding = useCallback(
    debounce(1000, (searchBuilValue: string, cityId: any, areaId?: any) => {
      searchBuilding(searchBuilValue, +cityId, +areaId);
    }),
    []
  );

  const handleBuilingSearch = (value: string, cityId: any, areaId?: any) => {
    dbounceBuilding(value, cityId, areaId);
  };

  async function searchBuilding(
    search: string,
    cityId: number,
    selectedAreaId?: any
  ) {
    try {
      if (search.length > 2) {
        const res = await HelperServices.getAllValidBuildings({
          area: +selectedAreaId,
          city: +cityId,
          smart_search: search,
        });
        setBuildings(get("data.data", res));
      }
    } catch (error) {
      console.log(error);
    }
  }

  function validateUpdateUser(values: any) {
    let errors: any = {};
    if (!values.user_id) {
      errors.user_id = t("REQUIRED", {
        field: t("USER").toLowerCase(),
      });
    }
    return errors;
  }

  function validateCreateUser(values: any) {
    let errors: any = {};
    if (!values.fname) {
      errors.fname = t("REQUIRED", {
        field: t("FIRST_NAME").toLowerCase(),
      });
    }
    if (!values.lname) {
      errors.lname = t("REQUIRED", {
        field: t("LAST_NAME").toLowerCase(),
      });
    }
    if (!values.email) {
      errors.email = t("REQUIRED", {
        field: t("EMAIL").toLowerCase(),
      });
    }
    if (!values.username) {
      errors.username = t("REQUIRED", {
        field: t("USERNAME").toLowerCase(),
      });
    }
    if (values.username && values.username.length < 4) {
      errors.username = t("AT_LEAST", {
        field: t("USERNAME"),
        char: 4,
      });
    }
    if (!values.mobile) {
      errors.mobile = t("REQUIRED", {
        field: t("MOBILE").toLowerCase(),
      });
    }
    if (values.mobile && values.mobile.length !== 10) {
      errors.mobile = t("VALID", {
        entity: t("MOBILE").toLowerCase(),
      });
    }

    if (!values.password) {
      errors.password = t("REQUIRED", {
        field: t("PASSWORD").toLowerCase(),
      });
    }
    if (!values.confirm_password) {
      errors.confirm_password = t("REQUIRED", {
        field: t("CONFIRM_PASSWORD").toLowerCase(),
      });
    }

    if (!values.country_id) {
      errors.country_id = t("REQUIRED", {
        field: t("COUNTRY").toLowerCase(),
      });
    }
    if (!values.state_id) {
      errors.state_id = t("REQUIRED", {
        field: t("STATE").toLowerCase(),
      });
    }
    if (!values.city_id) {
      errors.city_id = t("REQUIRED", {
        field: t("CITY").toLowerCase(),
      });
    }
    if (!values.area_name) {
      errors.area_name = t("REQUIRED", {
        field: t("AREA").toLowerCase(),
      });
    }
    if (!values.building) {
      errors.building = t("REQUIRED", {
        field: t("BUILDING").toLowerCase(),
      });
    }
    if (!values.house_no) {
      errors.house_no = t("REQUIRED", {
        field: t("HOUSE_NO").toLowerCase(),
      });
    }
    if (!values.pincode) {
      errors.pincode = t("REQUIRED", {
        field: t("PINCODE").toLowerCase(),
      });
    }
    if (values.address_mobile && values.address_mobile?.length !== 10) {
      errors.address_mobile = t("VALID", {
        entity: t("MOBILE").toLowerCase(),
      });
    }
    return errors;
  }

  useEffect(() => {
    // hide area result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react
    function handleClickOutside(event: any) {
      if (areaRef.current && !areaRef.current.contains(event.target)) {
        setAreas([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [areaRef]);

  useEffect(() => {
    // hide building result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react TP
    function handleClickOutsidebuilding(event: any) {
      if (buildingRef.current && !buildingRef.current.contains(event.target)) {
        setBuildings([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutsidebuilding);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsidebuilding);
    };
  }, [buildingRef]);

  function saveNewUser(val: any) {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key]) && key != "user_id") form.append(key, val[key]);
    }
    if (file) {
      form.append("image", file, file.name);
    }
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      form.set("comp_id", UtilityServices.getLoggedInUser("company_id"));
    } else {
      form.set("comp_id", companyId.toString());
    }
    form.set("role_id", forRole.toString());
    form.set("is_primary_user", "1");
    saveUser(form);
  }

  function saveExistingUser(val: any) {
    const form = new FormData();
    form.append("user_id", val["user_id"]);
    form.set("is_primary_user", "1");
    saveUser(form, +val["user_id"]);
  }

  const onSubmit = (val: any) => {
    if (createNewUser) {
      saveNewUser(val);
    } else {
      saveExistingUser(val);
    }
  };

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            content={t("LOADING")}
            center
            backdrop={true}
          />
        )}
        <Modal.Header>
          <h4>
            {" "}
            {t("SET") +
              " " +
              t("PRIMARY") +
              " " +
              t("USER") +
              " " +
              t("FOR") +
              " "}{" "}
            {displayField(`${companyData?.comp_name}`)}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container className="container">
            <Header className="header">
              <Radio
                onChangeCapture={(e: any) => {
                  if (e.target.checked) {
                    setCreateNewUser(true);
                  }
                }}
                checked={createNewUser ? true : false}
                name="toggle_create_user"
                value={1}
              >
                <h6>
                  {t("CREATE")} {t("NEW")} {t("USER")}
                </h6>
              </Radio>
              <Radio
                onChangeCapture={(e: any) => {
                  if (e.target.checked) {
                    setCreateNewUser(false);
                  }
                }}
                checked={!createNewUser ? true : false}
                name="toggle_create_user"
                value={0}
              >
                <h6>
                  {t("CHOOSE")} {t("EXISTING")} {t("USER")}
                </h6>
              </Radio>
            </Header>
            <Content className="content user-create-wrap">
              <Form
                onSubmit={onSubmit}
                validate={(values: any) => {
                  let errors: any = {};
                  if (createNewUser) {
                    errors = validateCreateUser(values);
                  } else {
                    errors = validateUpdateUser(values);
                  }
                  return errors;
                }}
                initialValues={{ ...formData }}
                render={({
                  handleSubmit,
                  form
                }) => (
                  <form onSubmit={handleSubmit}>
                    {createNewUser ? (
                      <div>
                        <Field name="image">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <div className="d-flex usr-img">
                                <div>
                                  <img
                                    className="usr-img-bx"
                                    src={
                                      file
                                        ? URL.createObjectURL(file)
                                        : updateUserImage
                                        ? updateUserImage
                                        : UtilityServices.getLoggedInUser(
                                            "user_default_image"
                                          )
                                    }
                                    alt={t("USER") + " " + t("IMAGE")}
                                    title={t("USER") + " " + t("IMAGE")}
                                  />
                                </div>
                                <input
                                  id="image-upload"
                                  {...input}
                                  type="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChangeCapture={(e: any) => {
                                    setFile(e.target.files[0]);
                                  }}
                                  style={{ display: "none" }}
                                />
                                <label
                                  className="user-image-upload-lbl"
                                  htmlFor="image-upload"
                                >
                                  {t("UPLOAD")} {t("IMAGE")}
                                </label>
                              </div>
                            </div>
                          )}
                        </Field>
                        <div className="form-part">
                          <div className="flex-container">
                            <Field
                              name="fname"
                              validate={
                                ValidatorCustom.isAlphaNumericPatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("FIRST_NAME")}*</label>
                                  <input {...input} type="text" />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="lname"
                              validate={
                                ValidatorCustom.isAlphaNumericPatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("LAST_NAME")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="email"
                              validate={ValidatorCustom.emailPatternValidator}
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("EMAIL")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field
                              name="username"
                              validate={
                                ValidatorCustom.whiteSpacePatterValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("USERNAME")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                    onChangeCapture={(e: any) => {
                                      let val = e.target.value;
                                      if (val && val.length > 3) {
                                        handleUsernameCheck(val);
                                      }
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                  {!meta.error &&
                                    meta.touched &&
                                    !isUsernameAllowed && (
                                      <span>
                                        {t("USERNAME_VALIDATION", {
                                          value: t(input.value),
                                        })}
                                      </span>
                                    )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="mobile"
                              validate={ValidatorCustom.mobilePatternValidation}
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("MOBILE")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="designation"
                              validate={
                                ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("DESIGNATION")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>

                          <div className="flex-container">
                            <Field
                              name="password"
                              validate={
                                ValidatorCustom.passwordPatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("PASSWORD")}*</label>
                                  <input
                                    {...input}
                                    type="password"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="confirm_password">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CONFIRM")} {t("PASSWORD")}*
                                  </label>
                                  <input
                                    {...input}
                                    type="password"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                  {!meta.error &&
                                    meta.touched &&
                                    form.getState().values.password &&
                                    form.getState().values.password !==
                                      form.getState().values
                                        .confirm_password && (
                                      <>
                                        <br />
                                        <span>
                                          {t("DOES_NOT_MATCH", {
                                            field1: t("CONFIRM_PASSWORD"),
                                            field2: t("PASSWORD").toLowerCase(),
                                          })}
                                        </span>
                                      </>
                                    )}
                                </div>
                              )}
                            </Field>
                            <div className="flex-item"></div>
                          </div>

                          <div className="flex-container">
                            <Field
                              name="emp_code"
                              validate={
                                ValidatorCustom.isAlphaNumericPatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("EMPLOYEE_CODE")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="receive_notification">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label className="inline">
                                    {t("RECEIVE_NOTIFICATION")}*
                                  </label>
                                  <Checkbox
                                    name="receive_notification"
                                    checked={
                                      input.value === onOffArr.on ? true : false
                                    }
                                    onChangeCapture={(e: any) => {
                                      if (e.target.checked) {
                                        form.change(
                                          "receive_notification",
                                          onOffArr.on
                                        );
                                      }
                                    }}
                                    value={onOffArr.on}
                                  >
                                    {t("YES")}
                                  </Checkbox>
                                  <Checkbox
                                    checked={
                                      input.value === onOffArr.off
                                        ? true
                                        : false
                                    }
                                    name="receive_notification"
                                    onChangeCapture={(e: any) => {
                                      if (e.target.checked) {
                                        form.change(
                                          "receive_notification",
                                          onOffArr.off
                                        );
                                      }
                                    }}
                                    value={onOffArr.off}
                                  >
                                    {t("NO")}
                                  </Checkbox>
                                </div>
                              )}
                            </Field>
                            <Field name="status">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label className="inline">
                                    {t("STATUS")}*
                                  </label>
                                  <Radio
                                    onChangeCapture={(e: any) => {
                                      if (e.target.checked) {
                                        form.change("status", statusArr.active);
                                      }
                                    }}
                                    checked={
                                      input.value === statusArr.active
                                        ? true
                                        : false
                                    }
                                    name="status"
                                    value={statusArr.active}
                                  >
                                    {t("ACTIVE")}
                                  </Radio>
                                  <Radio
                                    onChangeCapture={(e: any) => {
                                      if (e.target.checked) {
                                        form.change(
                                          "status",
                                          statusArr.inactive
                                        );
                                      }
                                    }}
                                    checked={
                                      input.value === statusArr.inactive
                                        ? true
                                        : false
                                    }
                                    name="status"
                                    value={statusArr.inactive}
                                  >
                                    {t("INACTIVE")}
                                  </Radio>
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                        </div>
                        <div className="address-bx">
                          <h5>
                            {t("ADDRESS")} ({" "}
                            <Checkbox
                              name="keep_address_same"
                              onChangeCapture={(e: any) => {
                                if (e.target.checked == true) {
                                  makeSameAddress(companyData, form);
                                }
                              }}
                              value={onOffArr.off}
                            ></Checkbox>
                            {t("KEEP_SAME_ADDRESS_AS", {
                              entity: t("COMPANY"),
                            })}{" "}
                            )
                          </h5>
                        </div>
                        <div className="form-part">
                          <div className="flex-container">
                            <Field name="country_id">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <CustomSelector
                                    loaderMsg={t("FETCHING_DATA_OF", {
                                      field: t("COUNTRY").toLocaleLowerCase(),
                                    })}
                                    isRequired={true}
                                    valueKey="id"
                                    labelKey="country_name"
                                    isDisable={
                                      !countryList?.length ? true : false
                                    }
                                    labelName={t("COUNTRY")}
                                    defaultValue={input.value}
                                    onClear={(event: any) => {
                                      form.change("country_id", "");
                                      form.change("state_id", "");
                                      form.change("city_id", "");
                                      form.change("building", "");
                                      form.change("area_name", "");
                                      setStateList([]);
                                      setCityList([]);
                                    }}
                                    listData={
                                      countryList?.length ? countryList : []
                                    }
                                    onSelect={(e: any, selectedObj: any) => {
                                      form.change("country_id", e);
                                      handleCountryChange(e);
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="state_id">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <CustomSelector
                                    loaderMsg={
                                      form.getState().values.country_id &&
                                      !stateList?.length
                                        ? t("FETCHING_DATA_OF", {
                                            field:
                                              t("STATE").toLocaleLowerCase(),
                                          })
                                        : ""
                                    }
                                    valueKey="id"
                                    labelKey="state_name"
                                    isRequired={true}
                                    isDisable={
                                      !stateList?.length ? true : false
                                    }
                                    labelName={t("STATE")}
                                    defaultValue={input.value}
                                    onClear={(event: any) => {
                                      form.change("state_id", "");
                                      form.change("city_id", "");
                                      form.change("building", "");
                                      form.change("area_name", "");
                                      setCityList([]);
                                    }}
                                    listData={
                                      form.getState().values.country_id &&
                                      stateList?.length
                                        ? stateList
                                        : [{}]
                                    }
                                    onSelect={(e: any, selectedObj: any) => {
                                      form.change("state_id", e);
                                      handleStateChange(e);
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                  {meta.error &&
                                    meta.touched &&
                                    form.getState().values.country_id &&
                                    !stateList?.length && <br />}
                                  {form.getState().values.country_id &&
                                    !stateList?.length &&
                                    !stateNotFound && (
                                      <span>
                                        {t("FETCHING_DATA_OF", {
                                          field: t("STATE"),
                                        })}
                                      </span>
                                    )}
                                  {form.getState().values.country_id &&
                                    !stateList?.length &&
                                    stateNotFound && (
                                      <span>
                                        {t("NO_DATA_FOUND_OF", {
                                          field: t("STATE").toLocaleLowerCase(),
                                        })}
                                      </span>
                                    )}
                                </div>
                              )}
                            </Field>
                            <Field name="city_id">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <CustomSelector
                                    loaderMsg={
                                      form.getState().values.state_id &&
                                      !cityList?.length
                                        ? t("FETCHING_DATA_OF", {
                                            field: t("CITY"),
                                          })
                                        : ""
                                    }
                                    valueKey="id"
                                    labelKey="city_name"
                                    isRequired={true}
                                    isDisable={!cityList?.length ? true : false}
                                    labelName={t("CITY")}
                                    defaultValue={input.value}
                                    onClear={(event: any) => {
                                      form.change("city_id", "");
                                      form.change("building", "");
                                      form.change("area_name", "");
                                    }}
                                    listData={
                                      form.getState().values.state_id &&
                                      cityList?.length
                                        ? cityList
                                        : [{}]
                                    }
                                    onSelect={(e: any, selectedObj: any) => {
                                      form.change("city_id", e);
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                  {meta.error &&
                                    meta.touched &&
                                    form.getState().values.state_id &&
                                    !cityList?.length && <br />}
                                  {form.getState().values.state_id &&
                                    !cityList?.length &&
                                    !cityNotFound && (
                                      <span>
                                        {t("FETCHING_DATA_OF", {
                                          field: t("CITY").toLocaleLowerCase(),
                                        })}
                                      </span>
                                    )}
                                  {form.getState().values.state_id &&
                                    cityNotFound && (
                                      <span>
                                        {t("NO_DATA_FOUND_OF", {
                                          field: t("CITY").toLocaleLowerCase(),
                                        })}
                                      </span>
                                    )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field name="house_no">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("HOUSE_NO")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="area_name"
                              validate={
                                ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item" ref={areaRef}>
                                  <label>{t("AREA")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    disabled={
                                      form.getState().values.city_id
                                        ? false
                                        : true
                                    }
                                    autoComplete="off"
                                    onChange={(event: any) => {
                                      handleAreaSearch(
                                        event.target.value,
                                        form.getState().values.city_id
                                      );
                                      form.change(
                                        "area_name",
                                        event.target.value
                                      );
                                    }}
                                  />
                                  {meta.modified && areas && areas.length ? (
                                    <div className="tarea-nm-bx">
                                      {areas &&
                                        areas.length &&
                                        areas.map((area: any, index) => {
                                          return (
                                            <div key={index}>
                                              <label
                                                className="tarea-nm-lbl"
                                                onClick={(e: any) => {
                                                  form.change(
                                                    "area_name",
                                                    area.area_name
                                                  );
                                                  setSelectedAreaId(area.id);
                                                  setAreas([]);
                                                }}
                                              >
                                                {area && area.area_name}
                                              </label>{" "}
                                              <br />
                                            </div>
                                          );
                                        })}
                                    </div>
                                  ) : null}
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="building"
                              validate={
                                ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item" ref={buildingRef}>
                                  <label>{t("BUILDING")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    disabled={
                                      form.getState().values.city_id
                                        ? false
                                        : true
                                    }
                                    autoComplete="off"
                                    onChange={(event: any) => {
                                      handleBuilingSearch(
                                        event.target.value,
                                        form.getState().values.city_id,
                                        selectedAreaId
                                      );
                                      form.change(
                                        "building",
                                        event.target.value
                                      );
                                    }}
                                  />
                                  {meta.modified && buildings?.length ? (
                                    <div className="tarea-nm-bx">
                                      {meta.touched &&
                                        buildings?.length &&
                                        buildings.map(
                                          (building: any, index) => {
                                            return (
                                              <div key={index}>
                                                <label
                                                  className="tarea-nm-lbl"
                                                  onClick={(e: any) => {
                                                    form.change(
                                                      "building",
                                                      building.building_name
                                                    );
                                                    setBuildings([]);
                                                  }}
                                                >
                                                  {building &&
                                                    building.building_name}
                                                </label>{" "}
                                                <br />
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>
                                  ) : null}
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field
                              name="landmark"
                              validate={
                                ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("LANDMARK")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="pincode"
                              validate={
                                ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("PINCODE")}*</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field
                              name="address_mobile"
                              validate={ValidatorCustom.mobilePatternValidation}
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("ADDRESS_MOBILE")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="flex-container">
                          <Field name="user_id">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={null}
                                  isRequired={true}
                                  valueKey="id"
                                  labelKey="name"
                                  labelName={t("USER")}
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    form.change("user_id", "");
                                  }}
                                  listData={userList?.length ? userList : []}
                                  onSelect={(e: any, selectedObj: any) => {
                                    form.change("user_id", e);
                                  }}
                                  value={companyData?.primary_user_id}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                                {!userList?.length && !userNotFound && (
                                  <span>
                                    {t("NO_DATA_FOUND_OF", {
                                      field: t("USER").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                                {!userList?.length && !userNotFound && (
                                  <span>
                                    {t("FETCHING_DATA_OF", {
                                      field: t("USER"),
                                    })}
                                  </span>
                                )}
                                {!userList?.length && userNotFound && (
                                  <span>
                                    {t("NO_DATA_FOUND_OF", {
                                      field: t("USER").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                              </div>
                            )}
                          </Field>                    
                        </div>                        
                      </div>                      
                    )}
                    <div className="create-action create-action-strt d-flex">
                      <Button
                        appearance="primary"
                        color="red"
                        type="button"
                        className="ml-0"
                        onClick={() => setOpenModal("")}
                      >
                        {t("CANCEL")}
                      </Button>
                      <Button
                        appearance="primary"
                        color="green"
                        type="submit"
                       
                      >
                        {createNewUser ? t("CREATE") : t("UPDATE")}
                      </Button>
                      <Button
                        appearance="default"
                        type="reset"
                        onClick={() => {
                          // review comment: move to new function
                          form.reset();
                          setFile("");
                          setUpdateUserImage("");
                          setIsUsernameAllowed(true);
                          if (form.getState().values.country_id) {
                            handleCountryChange(
                              form.getState().values.country_id
                            );
                          }
                          if (form.getState().values.state_id) {
                            handleStateChange(form.getState().values.state_id);
                          }
                        }}
                        
                      >
                        {t("RESET")}
                      </Button>
                    </div>

                    
                  </form>
                )}
              />
            </Content>
          </Container>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
}

export default UserForCompany;
